import type { RekapAbsensiRow } from '@app/shared';

export type RekapExportRow = {
  'Nama Pegawai': string;
  Sekolah: string;
  Hadir: number;
  Izin: number;
  Sakit: number;
  Alpha: number;
  'Persentase Kehadiran (%)': number;
};

/** Transformasi murni: pisahkan dari library agar mudah diuji. */
export function buildRekapExportRows(rows: RekapAbsensiRow[]): RekapExportRow[] {
  return rows.map((r) => ({
    'Nama Pegawai': r.nama,
    Sekolah: r.sekolahNama,
    Hadir: r.hadir,
    Izin: r.izin,
    Sakit: r.sakit,
    Alpha: r.alpha,
    'Persentase Kehadiran (%)': r.persentaseKehadiran,
  }));
}

export const REKAP_COLUMN_WIDTHS = [
  { wch: 28 },
  { wch: 20 },
  { wch: 8 },
  { wch: 8 },
  { wch: 8 },
  { wch: 8 },
  { wch: 22 },
];

/**
 * Ekspor rekap absensi ke file .xlsx.
 * Library `xlsx` dimuat secara dinamis (code-split) agar tidak membebani
 * chunk/bundle awal aplikasi.
 */
export async function exportRekapAbsensiXlsx(
  rows: RekapAbsensiRow[],
  fileName: string,
): Promise<void> {
  if (rows.length === 0) {
    throw new Error('Tidak ada data untuk diekspor');
  }
  const XLSX = await import('xlsx');
  const ws = XLSX.utils.json_to_sheet(buildRekapExportRows(rows));
  ws['!cols'] = REKAP_COLUMN_WIDTHS;
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Rekap Absensi');
  XLSX.writeFile(wb, fileName);
}
